(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["card-discount-code"] && !Shopify.designMode) return;
  try {
    if (!window.cartDiscountCodeFormInitialized) {
    window.cartDiscountCodeFormInitialized = true;

    document.addEventListener('submit', function(event) {
      const form = event.target.closest('[data-discount-code-form]');

      if (!form) {
        return;
      }

      event.preventDefault();
      hideCartDiscountError(form);

      const input = form.querySelector('[name="discount"]');
      const code = input.value.trim();

      if (!code) {
        input.focus();
        return;
      }

      const button = form.querySelector('button[type="submit"]');
      const sections = getCartDiscountSectionsToRender();
      const body = JSON.stringify({
        discount: code,
        sections: sections.map(function(section) {
          return section.section;
        }),
        sections_url: window.location.pathname,
      });

      setCartDiscountButtonLoading(button, true);
      fetch(routes.cart_update_url, {
        ...fetchConfig(),
        body: body,
      })
        .then(function(response) {
          return response.json();
        })
        .then(function(parsedState) {
          if (cartDiscountCodeIsRejected(parsedState, code)) {
            showCartDiscountError(form, code);
            input.focus();
            return;
          }

          renderCartDiscountSections(parsedState, sections);
          showAppliedCartDiscountMessage(code, parsedState);
          input.value = '';
          input.focus();

          if (typeof publish === 'function' && window.PUB_SUB_EVENTS) {
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'cart-discount-code',
              cartData: parsedState,
            });
          }
        })
        .catch(function(error) {
          console.error(error);
        })
        .finally(function() {
          setCartDiscountButtonLoading(button, false);
        });
    });

    document.addEventListener('click', function(event) {
      const removeButton = event.target.closest('[data-discount-code-remove]');

      if (removeButton) {
        event.preventDefault();
        removeCartDiscountCode(removeButton);
        return;
      }

      const appliedMessageCloseButton = event.target.closest('[data-discount-code-applied-message-close]');

      if (appliedMessageCloseButton) {
        hideAppliedCartDiscountMessage(appliedMessageCloseButton.closest('[data-discount-code-applied-message]'));
        return;
      }

      const closeButton = event.target.closest('[data-discount-code-error-close]');

      if (!closeButton) {
        return;
      }

      hideCartDiscountError(closeButton.closest('.cart-discount-code-wrapper'));
    });
  }

  function setCartDiscountButtonLoading(button, isLoading) {
    button.disabled = isLoading;
    button.classList.toggle('is-loading', isLoading);
  }

  function showAppliedCartDiscountMessage(code, parsedState) {
    const formattedSavings = formatCartDiscountMoney(parsedState.total_discount, parsedState.currency);

    document.querySelectorAll('[data-applied-discount-code]').forEach(function(removeButton) {
      if (removeButton.dataset.appliedDiscountCode.toLowerCase() !== code.toLowerCase()) {
        return;
      }

      const wrapper = removeButton.closest('.cart-discount-code-wrapper');
      const message = removeButton.closest('.cart-discount-code-applied__item').querySelector('[data-discount-code-applied-message]');
      const messageText = message.querySelector('[data-discount-code-applied-message-text]');
      const template = decodeCartDiscountHTML(wrapper.querySelector('[data-discount-code-form]').dataset.appliedMessage);

      messageText.textContent = template.replace('[code]', removeButton.dataset.appliedDiscountCode).replace('[savings]', formattedSavings);
      message.hidden = false;
    });
  }

  function decodeCartDiscountHTML(value) {
    const textarea = document.createElement('textarea');
    textarea.innerHTML = value;
    return textarea.value;
  }

  function hideAppliedCartDiscountMessage(message) {
    if (!message) {
      return;
    }

    const messageText = message.querySelector('[data-discount-code-applied-message-text]');

    message.hidden = true;

    if (messageText) {
      messageText.textContent = '';
    }
  }

  function formatCartDiscountMoney(value, currency) {
    const amount = Number(value || 0) / 100;

    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency',
        currency: currency || 'USD',
      }).format(amount);
    } catch (error) {
      return '$' + amount.toFixed(2);
    }
  }

  function removeCartDiscountCode(removeButton) {
    const codeToRemove = removeButton.dataset.appliedDiscountCode;
    const appliedCodes = Array.from(document.querySelectorAll('[data-applied-discount-code]'))
      .map(function(button) {
        return button.dataset.appliedDiscountCode;
      })
      .filter(function(code, index, codes) {
        return code && codes.indexOf(code) === index && code !== codeToRemove;
      });
    const sections = getCartDiscountSectionsToRender();
    const body = JSON.stringify({
      discount: appliedCodes.join(','),
      sections: sections.map(function(section) {
        return section.section;
      }),
      sections_url: window.location.pathname,
    });

    removeButton.disabled = true;
    fetch(routes.cart_update_url, {
      ...fetchConfig(),
      body: body,
    })
      .then(function(response) {
        return response.json();
      })
      .then(function(parsedState) {
        renderCartDiscountSections(parsedState, sections);

        if (typeof publish === 'function' && window.PUB_SUB_EVENTS) {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'cart-discount-code',
            cartData: parsedState,
          });
        }
      })
      .catch(function(error) {
        console.error(error);
      })
      .finally(function() {
        removeButton.disabled = false;
      });
  }

  function cartDiscountCodeIsRejected(parsedState, code) {
    const discountCodes = parsedState.discount_codes || [];
    const normalizedCode = code.toLowerCase();

    return discountCodes.some(function(discountCode) {
      return discountCode.code.toLowerCase() === normalizedCode && discountCode.applicable === false;
    });
  }

  function showCartDiscountError(form, code) {
    const wrapper = form.closest('.cart-discount-code-wrapper');
    const error = wrapper.querySelector('[data-discount-code-error]');
    const errorText = wrapper.querySelector('[data-discount-code-error-text]');
    const message = form.dataset.errorMessage.replace('[code]', code);

    errorText.textContent = message;
    error.hidden = false;
  }

  function hideCartDiscountError(element) {
    const wrapper = element.closest('.cart-discount-code-wrapper');

    if (!wrapper) {
      return;
    }

    const error = wrapper.querySelector('[data-discount-code-error]');
    const errorText = wrapper.querySelector('[data-discount-code-error-text]');

    if (error && errorText) {
      error.hidden = true;
      errorText.textContent = '';
    }
  }

  function getCartDiscountSectionsToRender() {
    const sections = [];
    const cartFooter = document.getElementById('main-cart-footer');

    function addSection(section) {
      const exists = sections.some(function(existingSection) {
        return existingSection.section === section.section && existingSection.selector === section.selector;
      });

      if (!exists) {
        sections.push(section);
      }
    }

    if (cartFooter) {
      addSection({
        id: 'main-cart-footer',
        section: cartFooter.dataset.id,
        selector: '.js-contents',
      });
      addSection({
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '#cart-icon-bubble',
      });
    }

    if (document.getElementById('CartDrawer')) {
      addSection({
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.cart-drawer__footer',
      });
      addSection({
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '#cart-icon-bubble',
      });
    }

    return sections;
  }

  function renderCartDiscountSections(parsedState, sections) {
    sections.forEach(function(section) {
      const sectionHTML = parsedState.sections && parsedState.sections[section.section];
      const container = document.getElementById(section.id);

      if (!sectionHTML || !container) {
        return;
      }

      const targetElement = container.querySelector(section.selector) || container;
      const sourceElement = new DOMParser()
        .parseFromString(sectionHTML, 'text/html')
        .querySelector(section.selector);

      if (targetElement && sourceElement) {
        targetElement.innerHTML = sourceElement.innerHTML;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
